import http from "../http-common";

class SePayConnectionService {
    /**
     * Đại lý đại diện cho 1 trường
     */

    /**
     * Tạo token
     */
    createTokenSePayConnection() {
        return  http.post(`admin/online-payment/token/create`)
    }

    /**
     * Tạo token
     */
    createTokenSePayConnectionV2() {
        return  http.post(`admin/online-payment/token/create/v2`)
    }

    /**
     * Lấy danh sách ngân hàng SePay hiện hỗ trợ cho admin
     */
    getSePayConnectionServiceSupport() {
        return http.get(`admin/online-payment/bank-supported`);
    }

    /**
     * Lấy danh sách đại lý (đại diện cho trường) quản lý
     */
    getListBrandSchoolAccount(idSchool, limit, page) {
        return http.get(`admin/online-payment/company/list-company`, {params: {idSchool, limit, page}});
    }

    /**
     * Tạo đại lý
     */
    createBrandSchoolAccount(data) {
        return http.post(`admin/online-payment/company/create`, data);
    }

    /**
     * Tạo đại lý V2
     */
    createCompanyV2(data) {
        return http.post(`admin/online-payment/v2/company/create`, data);
    }

    /**
     * Cập nhật đại lý
     */
    updateBrandSchoolAccount(data) {
        return http.post(`admin/online-payment/company/update`, data);
    }

    /**
     * Cập nhật đại lý V2
     */
    updateCompanyV2(data) {
        return http.post(`admin/online-payment/v2/company/update`, data);
    }

    /**
     * Lấy cấu hình đại lý
     */
    getDetailConfigBrandSchoolAccount(idCompany) {
        return http.get(`admin/online-payment/company/config`, {params: {idCompany: idCompany}});
    }

    /**
     * Lấy cấu hình đại lý V2
     */
    getDetailCompanyV2(xid) {
        return http.get(`admin/online-payment/v2/company/config/${xid}`);
    }

    /**
     * Cập nhật cấu hình đại lý
     */
    updateConfigBrandSchoolAccount(data) {
        return http.post(`admin/online-payment/company/update-config`, data);
    }

    /**
     * Cập nhật cấu hình đại lý V2
     */
    updateCompanyConfigV2(data) {
        return http.post(`admin/online-payment/v2/company/update-config`, data);
    }


    /**
     * Lấy danh sách ngân hàng SePay hiện hỗ trợ cho plus
     */
    getSePayConnectionServiceSupportToPlus() {
        return http.get(`plus/online-payment/bank-supported`);
    }

    /**
     * Gửi liên kết tạo tài khoản
     */
    connectionSePayBySchool(data) {
        return http.post(`plus/online-payment/bank-account/send-create`, data);
    }

    /**
     * Gửi liên kết tạo tài khoản không cần nhập thông tin nữa
     */
    sendRequestCreateBankAccountReload(data) {
        return http.post(`plus/online-payment/bank-account/send-create/reload`, data);
    }

    /**
     * Nhập OTP xác thực
     */
    authenticationOTP(data) {
        return http.post(`plus/online-payment/bank-account/confirm-send-create`, data);
    }

    /**
     * Gửi lại OTP xác thực
     */
    reloadAuthenticationOTP(data) {
        return http.post(`plus/online-payment/bank-account/require-create`, data);
    }

    /**
     * Lấy danh sách tài khoản cho plus
     */
    findAllDataByPlus(accountNumber, limit, page) {
        return http.get(`plus/online-payment/bank-account/list-bank`, {params: {accountNumber, limit, page}});
    }

    /**
     * Lấy danh sách tài khoản cho admin
     */
    findAllDataByAdmin(delActive, accountNumber, idSchool, statusBankApiConnected, statusBillPayment, limit, page) {
        return http.get(`admin/online-payment/list-bank`, {
            params: {
                delActive,
                accountNumber,
                idSchool,
                statusBankApiConnected,
                statusBillPayment,
                limit,
                page
            }
        });
    }

    /**
     * Bật tắt QR plus
     */
    showQRBanks(id, showQR) {
        return http.get(`plus/online-payment/bank-account/show-qr`, {params: {id, showQR}});
    }

    /**
     * Bật tắt QR  admin
     */
    showQRBanksAdmin(id, idSchool, showQR) {
        return http.get(`admin/online-payment/bank-account/show-qr`, {params: {id, idSchool, showQR}});
    }

    /**
     * Bật tắt QR cho tải khoản VA
     */
    showQRBankVA(id, showQR) {
        return http.get(`plus/online-payment/bank-account/va/show-qr`, {params: {id, showQR}});
    }


    /**
     * Bật tắt QR cho tải khoản VA
     */
    showQRBankVAByAdmin(id, showQR, idSchool) {
        return http.get(`admin/online-payment/bank-account/va/show-qr`, {params: {id, showQR, idSchool}});
    }



    updatePriority(id, number, moneyLimit) {
        return http.get(`plus/online-payment/bank-account/update/priority`, {params: {id, number, moneyLimit}});
    }

    /**
     * Gửi liên kết hủy liên kết tài khoản từ plus
     */
    sendRequestDeleteBankAccount(data) {
        return http.post(`plus/online-payment/bank-account/send-delete`, data);
    }

    /**
     * Gửi liên kết hủy liên kết tài khoản từ admin
     */
    sendRequestDeleteBankAccountByAdmin(data, id) {
        return http.post(`admin/online-payment/bank-account/send-delete/${id}`, data);
    }

    /**
     * Nhập OTP xác thực hủy liên kết tài khoản
     */
    confirmRequestDeleteBankAccount(data) {
        return http.post(`plus/online-payment/bank-account/confirm-send-delete`, data);
    }

    /**
     * Xóa tài khoản ngân hàng bới plus
     */
    forceDeleteBankAccount(data) {
        return http.post(`plus/online-payment/bank-account/force-delete`, data);
    }

    /**
     * Xóa tài khoản ngân hàng bới admin
     */
    forceDeleteBankAccountByAdmin(data) {
        return http.post(`admin/online-payment/bank-account/force-delete`, data);
    }

    /**
     * Tạo tài khoản VA cho KienLongBank
     */
    sendRequestCreateBankAccountVAKienLongBank(data) {
        return http.post(`plus/online-payment/bank-account/send-create/va/klb`, data);
    }

    /**
     * Vô hiệu hóa tài khoản VA của KienLongBank
     */
    sendRequestDisableBankAccountVAKienLongBank(id) {
        return http.post(`plus/online-payment/bank-account/disable/va/klb/${id}`);
    }

    /**
     * Vô hiệu hóa tài khoản VA của KienLongBank
     */
    sendRequestDisableBankAccountVAKienLongBankByAdmin(id) {
        return http.post(`admin/online-payment/bank-account/disable/va/klb/${id}`);
    }

    /**
     * Kích hoạt lại hóa tài khoản VA của KienLongBank
     */
    sendRequestEnableBankAccountVAKienLongBank(id) {
        return http.post(`plus/online-payment/bank-account/enable/va/klb/${id}`);
    }

    /**
     * Kích hoạt lại hóa tài khoản VA của KienLongBank
     */
    sendRequestEnableBankAccountVAKienLongBankByAdmin(id) {
        return http.post(`admin/online-payment/bank-account/enable/va/klb/${id}`);
    }

    /**
     * Vô hiệu hóa tài khoản VA của OCB
     */
    sendRequestDisableBankAccountVAOCB(id) {
        return http.get(`plus/online-payment/bank-account/disable/va/ocb/${id}`);
    }

    /**
     * Vô hiệu hóa tài khoản VA của OCB
     */
    sendRequestDisableBankAccountVAOCBByAdmin(id) {
        return http.get(`admin/online-payment/bank-account/disable/va/ocb/${id}`);
    }

    /**
     * Kích hoạt lại hóa tài khoản VA của OCB
     */
    sendRequestEnableBankAccountVAOCB(id) {
        return http.get(`plus/online-payment/bank-account/enable/va/ocb/${id}`);
    }

    /**
     * Kích hoạt lại hóa tài khoản VA của OCB
     */
    sendRequestEnableBankAccountVAOCBByAdmin(id) {
        return http.get(`admin/online-payment/bank-account/enable/va/ocb/${id}`);
    }


    /**
     * Khởi tạo số VA cho OCB
     */
    initializationVANumberOCB() {
        return http.get(`plus/online-payment/bank-account/create/va/ocb`)
    }

    /**
     * Lấy OTP cho VA của OCB
     */
    sendRequestCreateBankOCBAccount(data) {
        return http.post(`plus/online-payment/bank-account/send-create/ocb`, data);
    }

    /**
     * Xác nhận liên kết tài khoản VA của OCB
     */
    confirmRequestCreateBankOCBAccount(data) {
        return http.post(`plus/online-payment/bank-account/confirm-send-create/ocb`, data);
    }

    /**
     * Lấy danh sách đại lý đang hoạt động
     */
    findAllCompaniesActive() {
        return http.get(`admin/online-payment/list-company/active`);
    }

    /**
     * Lấy danh sách ngân hàng đang hoạt động
     */
    findAllBanksAPIActive() {
        return http.get(`admin/online-payment/list-bank/active`);
    }

    /**
     * Thêm tài khoản ngân hàng có sẵn cho trường
     */
    addBanksByAdmin(data) {
        return http.post(`admin/online-payment/add-bank/active`, data);
    }

    /**
     * Bật hoặc tắt sử dụng tài khoản VA để đồng bộ giao dịch.
     */
    updateUseVASynchronization(id, useVASynchronization) {
        return http.get(`admin/online-payment/update-use-va-synchronization`, {params: {id, useVASynchronization}});
    }

    /**
     * Lấy lịch sử giao dịch cho plus
     */
    getTransactionHistoryForPlus(startDate, endDate, transferType, accountNumber, name, idClass, limit, page) {
        return http.get(`plus/online-payment/transaction/transaction-history`, {params: {startDate, endDate, transferType, accountNumber, name, idClass, limit, page}});
    }
    /**
     * Lấy lịch sử giao dịch ngoài trường cho plus
     */
    getTransactionHistoryForPlusOutSchool(startDate, endDate, transferType, accountNumber, limit, page) {
        return http.get(`plus/online-payment/transaction/transaction-history/out-school`, {params: {startDate, endDate, transferType, accountNumber, limit, page}});
    }


    /**
     * Lấy lịch sử giao dịch cho admin
     */
    getTransactionHistoryForAdmin(startDate, endDate, transferType, accountNumber, idSchool, name, idClass, limit, page) {
        return http.get(`/admin/online-payment/transaction/transaction-history`, {params: {startDate, endDate, transferType, accountNumber, idSchool, name, idClass, limit, page}});
    }

    /**
     * Lấy lịch sử giao dịch cho admin
     */
    getTransactionHistoryForAdminOutSchool(startDate, endDate, transferType, accountNumber, idSchool, limit, page) {
        return http.get(`/admin/online-payment/transaction/transaction-history/out-school`, {params: {startDate, endDate, transferType, accountNumber, idSchool, limit, page}});
    }

    /**
     * Thống kê số lượng giao dịch dùng cho nhà trường
     */
    getTotalTransactionForPlus(startDate, endDate, transferType, accountNumber, year, belongOnekids) {
        return http.get(`plus/online-payment/transaction/total-transaction`, {params: {startDate, endDate, transferType, accountNumber, year, belongOnekids}});
    }

    /**
     * Thống kê số lượng giao dịch dùng cho admin
     */
    getTotalTransactionForAdmin(startDate, endDate, transferType, accountNumber, year, idSchool, belongOnekids) {
        return http.get(`/admin/online-payment/transaction/total-transaction`, {params: {startDate, endDate, transferType, accountNumber, year, idSchool, belongOnekids}});
    }


    /**
     * Bộ đếm giao dịch cho oneadmin
     */
    getCounterForAdmin(startDate, endDate, limit, page) {
        return http.get(`/admin/online-payment/counter-transaction/manager`, {params: {startDate, endDate, limit, page}});
    }

    /**
     * Cập nhật bộ đếm
     */
    getCounterForMerchant(data) {
        return http.post(`/admin/online-payment/counter-transaction/merchant`,data);
    }

    /**
     * Đồng bộ lịch sử giao dịch
     */
    syncTransactionHistory(date) {
        return http.get(`/admin/online-payment/counter-transaction/sync-transaction-history/${date}`);
    }
    /**
     * Tạo row bộ đếm cho 1 năm
     */
    generateDaysForCurrentYearIfNotExist() {
        return  http.get(`/admin/online-payment/counter-transaction/create/count-generate-days`)
    }

    /**
     * Kiểm tra hoạt đồng của webhook
     */
    checkWebhookConnection() {
        return  http.get(`/onekids/online-payment/check/webhook/connection`)
    }

    /**
     * Lấy cấu hình của company
     */
    getInfoStudentOnlinePayment() {
        return  http.get(`plus/online-payment/config-company`)
    }

    /**
     * Lấy danh sách vượt hạn mức
     */
    findHistoryChangeStudentOnlinePayment(month, year, limit, page) {
        return  http.get(`plus/online-payment/history-change-student`, {params: {month, year, limit, page}});
    }
    /**
     * Lấy danh sách chi tiết học sinh vượt hạn mức
     */
    findKidsChangeOnlinePayment(idHistory, type, limit, page) {
        return  http.get(`plus/online-payment/history-change-student/detail`, {params: {idHistory, type, limit, page}});
    }

    /**
     * Lấy danh sách  học sinh từ admin
     */
    searchKidsByAdmin(pageNumber, maxPageItem, loginStatus, status, idGrade, idClass, nameOrPhone, type, dateList, idSchool) {
        return http.get(`/admin/online-payment/search/student?pageNumber=${pageNumber}&maxPageItem=${maxPageItem}&loginStatus=${loginStatus}&status=${status}&idGrade=${idGrade}&idClass=${idClass}&nameOrPhone=${nameOrPhone}&type=${type}&dateList=${dateList}&idSchool=${idSchool}`);
    }

    updateStatusOnlinePaymentAdmin(idKid, enableOnlinePayment, idSchool) {
        return http.get(`/admin/online-payment/updateStatusOnlinePayment`, {params: {idKid, enableOnlinePayment, idSchool}});
    }

    updateStatusOnlinePaymentByListAdmin(data) {
        return http.post(`/admin/online-payment/updateStatusOnlinePayment/list`, data);
    }

    /**
     * Lấy cấu hình của company bởi admin
     */
    getInfoStudentOnlinePaymentAmin(id) {
        return  http.get(`/admin/online-payment/config-company/${id}`)
    }

    /**
     * Lấy danh sách vượt hạn mức bởi admin
     */
    findHistoryChangeStudentOnlinePaymentAdmin(month, year, limit, page, idSchool) {
        return  http.get(`/admin/online-payment/history-change-student`, {params: {month, year, limit, page, idSchool}});
    }
    /**
     * Lấy danh sách chi tiết học sinh vượt hạn mức
     */
    findKidsChangeOnlinePaymentAdmin(idHistory, type, limit, page) {
        return  http.get(`/admin/online-payment/history-change-student/detail`, {params: {idHistory, type, limit, page}});
    }
    /**
     * Danh sách khối trong trường
     */
    searchGradeInSchool(idSchool){
        return  http.get(`/admin/online-payment/grade-in-school`, {params: {idSchool}});
    }
    /**
     * Tìm kiếm danh dách lớp theo khối
     */
    searchClassInGrade(idSchool, idGrade){
        return  http.get(`/admin/online-payment/class-in-grade`, {params: {idSchool, idGrade}});
    }

    /**
     * Lấy danh sách ngân hàng cho trường
     */
    findListBankForSchool(){
        return http.get(`plus/online-payment/search/bank/school`)
    }

    registerBankAccountForSchool(data){
        return http.post(`plus/online-payment/register/bank-account/school`,data)
    }

    /**
     * Lấy Company XID của trường để tạo Link Token
     */
    getCompanyXidForSchool() {
        return http.get(`/online-payment/bank-hub/xid-company`);
    }

    /**
     * Cập nhật tài khoản
     */
    syncDataFromSePay(){
        return http.post(`/plus/online-payment/v2/bank-account/sync-data-from-sepay`)
    }
}

export default new SePayConnectionService();